const projectNamespace = 'fee-schedule'

const nodeEnv = process.env.NODE_ENV;
const isDevSite = window.location.hostname.split('.')[0] === 'dev';

const isLocal = !nodeEnv;
const isDevelopment = nodeEnv === 'development' || isDevSite;
const isProduction = nodeEnv === 'production' && !isDevSite;

const storageKeySharedState = 'org.epo.mailbox.shared_state'

const publicUrl = isProduction
    ? (window as any)._env_.publicUrl
    : process.env.PUBLIC_URL;

const backendUrl = isProduction
    ? (window as any)._env_.backendUrl
    : process.env.BACKEND_URL;

const xAmbasadorUsername = isDevelopment && process.env.X_AMBASADOR_USERNAME;
const xAmbasadorPassword = isDevelopment && process.env.X_AMBASADOR_PASSWORD;

const Configs = {
    IS_LOCAL: isLocal,
    IS_DEVELOPMENT: isDevelopment,
    IS_PRODUCTION: isProduction,
    PROJECT_NAMESPACE: projectNamespace,
    STORAGE_KEY_SHARED_STATE: storageKeySharedState,
    X_AMBASADOR_USERNAME: xAmbasadorUsername,
    X_AMBASADOR_PASSWORD: xAmbasadorPassword,
    PUBLIC_URL: publicUrl,
    BACKEND_URL: backendUrl
};

Object.freeze(Configs);

export default Configs;